import { all, call, fork, put, takeEvery, select } from 'redux-saga/effects';
import {
    SIGNIN_USER_PASSWORDLESS,
    SIGNIN_USER,
    SIGNOUT_USER,
    REQUEST_SIGNIN_ACCESS_CODE,
} from 'constants/ActionTypes';
import { showAuthMessage, userSignInSuccess, userSignOutSuccess, userRequestSignInCodeSuccess } from 'actions/Auth';
import { clearSelectedObjects } from 'actions/session';
import { fetchOrgsAndSelectOrg } from 'actions/Organisation';
import { fetchNotifications } from 'actions/Employee';
import { postDataRequest, getDataRequest } from 'services/ApiService';
import { setAuth, invalidateSession, setIdentity } from 'services/Authentication';

function* signInUserWithUsernamePassword({ payload }) {
    const { username, password } = payload;
    const credentials = {
        username,
        password
    };
    try {
        const signInUser = yield call(postDataRequest, 'signIn', credentials);
        setAuth(signInUser);
        const identity = yield call(getDataRequest, 'identity');
        setIdentity(identity);
        yield put(fetchNotifications(identity));
        yield put(userSignInSuccess(signInUser));
        yield put(clearSelectedObjects()); // clear all selected objects on login in the store
    } catch (error) {
        yield put(showAuthMessage(error.messages));
    }
}

function* requestSignInAccessCode({ payload }) {
    const { username } = payload;
    const credentials = {
        username,
        passwordless: true,
    };
    try {
        const signInUserAccessCode = yield call(postDataRequest, 'signIn', credentials);
        yield put(userRequestSignInCodeSuccess(signInUserAccessCode));
    } catch (error) {
        yield put(showAuthMessage(error.messages));
    }
}

const getAuthUserCode = (state) => state.auth.authUserCode;

function* signInUserPasswordless({ payload }) {
    const { username, code } = payload;
    const credentials = {
        username,
        code,
        passwordless: true,
    };
    try {
        const authUserCode = yield select(getAuthUserCode);
        const { privateChallengeParameter, challengeMetadata } = authUserCode;
        const authHeader = { privateChallengeParameter, challengeMetadata };
        const signInUser = yield call(postDataRequest, 'signIn', credentials, authHeader);
        setAuth(signInUser);
        const identity = yield call(getDataRequest, 'identity');
        setIdentity(identity);
        yield put(fetchOrgsAndSelectOrg(identity ?.orgid));
        yield put(fetchNotifications(identity));
        yield put(userSignInSuccess(signInUser));
        yield put(clearSelectedObjects()); // clear all selected objects on login in the store
    } catch (error) {
        yield put(showAuthMessage(error.messages));
    }
}

// const signInUserPasswordlessRequest = async (credentials, authHeader) => {
//     return postDataRequest('signIn', credentials, authHeader);
// };

const signOutRequest = async () => {
    await invalidateSession();
    return;
};

function* signOut() {
    try {
        const signOutUser = yield call(signOutRequest);
        if (signOutUser && signOutUser.message) {
            yield put(showAuthMessage(signOutUser.messages));
        } else {
            yield put(userSignOutSuccess(signOutUser));
            yield put(clearSelectedObjects()); // clear all selected objects on logout in the store
        }
    } catch (error) {
        yield put(showAuthMessage(error.messages));
    }
}

export function* signInUserSaga() {
    yield takeEvery(SIGNIN_USER, signInUserWithUsernamePassword);
}

export function* signInUserPasswordlessSaga() {
    yield takeEvery(SIGNIN_USER_PASSWORDLESS, signInUserPasswordless);
}

export function* requestSignInAccessCodeSaga() {
    yield takeEvery(REQUEST_SIGNIN_ACCESS_CODE, requestSignInAccessCode);
}

export function* signOutUserSaga() {
    yield takeEvery(SIGNOUT_USER, signOut);
}

export default function* rootSaga() {
    yield all([
        fork(signInUserSaga),
        fork(signInUserPasswordlessSaga),
        fork(requestSignInAccessCodeSaga),
        fork(signOutUserSaga)]);
}


// WEBPACK FOOTER //
// ./sagas/Auth.js